import { ToastClose, ToastDescription, ToastProvider, ToastRoot, ToastTitle, ToastViewport } from './toast'
import { useToast } from './use-toast'

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, ...props }) => (
        <ToastRoot key={id} {...props}>
          <div className="grid gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && (
              <ToastDescription>
                {description}
                {action?.props.variant === 'link' && <> {action}</>}
              </ToastDescription>
            )}
          </div>
          {(!description || action?.props.variant !== 'link') && action}
          <ToastClose />
        </ToastRoot>
      ))}
      <ToastViewport />
    </ToastProvider>
  )
}
